import React, { useState, useEffect } from "react";
import { mainApi } from "../../providers/api";
import Loading from "../../components/Loading";
import { API_ROOT, convertT } from "../../defines";
import objectPath from "object-path";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { RiDeleteBin3Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { useApp } from "../../providers/app";
import { useTranslation } from "react-i18next";
const BasketItem = ({ item, setlist, list }) => {
  const { t } = useTranslation();
  const { refreshNoti } = useApp();
  const [count, setcount] = useState(objectPath.get(item, "count"));
  const [total, settotal] = useState(objectPath.get(item, "total_price"));
  const remove = () => {
    Swal.fire({
      title: `删除该留言信息吗`,
      icon: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "是的",
      cancelButtonText: "不",
    }).then((result) => {
      if (result.isConfirmed) {
        const cart = localStorage.getItem("cart");
        const list = cart ? JSON.parse(cart) : [];
        const newList = list.filter((i) => i == item);
        localStorage.setItem("cart", JSON.stringify(newList));

        refreshNoti();
        window.location.reload();
      }
    });
  };
  const change = () => {
    setcount((prev) => prev + 1);
    const index = list.findIndex((r) => r == item);
    const temp = list;
    settotal(count * objectPath.get(item, "price"));
    temp[index].count = count;
    temp[index].total_price = total;

    localStorage.setItem("cart", JSON.stringify(temp));
    console.log("🚀 ~ change ~ temp:", temp);

    // setlist(temp);
    // window.location.reload();
  };

  return (
    <div className="flex w-full flex-wrap justify-between p-8 bg-white rounded-md shadow-md mb-4 md:h-52">
      <div className="flex flex-wrap">
        <img
          src={API_ROOT + "/" + objectPath.get(item, "image")}
          crossOrigin="anonymous"
          className="w-full md:w-24 object-contain"
        />

        <div className="flex flex-col px-4">
          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              符号名称
              {/* Тэмдгийн нэр */}
            </div>
            <div className="font-medium text-base">
              {objectPath.get(item, "name")}
            </div>
          </div>
          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              材料
              {/* Материал */}
            </div>
            <div className="font-medium text-base">
              {objectPath.get(item, "materialObj.name")}
            </div>
          </div>
          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              {/* Хэмжээ */}
              尺寸
            </div>
            <div className="font-medium text-base">
              {objectPath.get(item, "sizeObj.name")}
            </div>
          </div>
        </div>
        <div className="flex flex-col px-4">
          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              有覆盖吗
              {/* Бүрэлттэй эсэх */}
            </div>
            <div className="font-medium text-base">
              {objectPath.get(item, "isCoat") ? "是的" : "不"}
            </div>
          </div>
          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              作品价格
              {/* Ширхэгийн үнэ */}
            </div>
            <div className="font-medium text-base">
              {convertT(objectPath.get(item, "price"))}
            </div>
          </div>

          <div className="mb-2">
            <div className="italic font-normal text-gray-500 text-sm">
              总价
              {/* Нийт үнэ */}
            </div>
            <div className="font-medium text-base">{convertT(total)}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-col px-4 w-48">
        <div className="mb-2 flex justify-between items-start">
          <div className="">
            <div className="italic font-normal text-gray-500 text-sm">
              酥脆
              {/* Ширхэг */}
            </div>
            <div className="font-medium text-base">{count}</div>
          </div>
          <div
            className="flex justify-end items-start invisible md:visible"
            onClick={remove}
          >
            <RiDeleteBin3Line color="red" />
          </div>
        </div>
        <div className="flex justify-between items-center p-4 ">
          <div
            onClick={() => setcount((prev) => (prev > 1 ? prev - 1 : 0))}
            className="flex border rounded bg-primary text-white w-8 h-8 text-xl justify-center items-center hover:cursor-pointer"
          >
            -
          </div>
          <div className="text-3xl font-bold mx-4">{count}</div>
          <div
            onClick={() => change(1)}
            className="flex border rounded bg-primary text-white w-8 h-8 text-xl justify-center items-center hover:cursor-pointer"
          >
            +
          </div>
        </div>
      </div>
      <div
        onClick={remove}
        className="flex bg-red-500 justify-center items-center w-full hover:cursor-pointer p-2 rounded-lg visible md:invisible"
      >
        <div className="text-white font-medium">{t("remove")}</div>
      </div>
    </div>
  );
};

export default BasketItem;
